<template>
  <v-container id="contact-grid" grid-list-xl>
    <!-- contact breadcrumb -->
    <div
      v-if="shownotif"
      class="alert alert-success alert-dismissible fade show"
      role="alert"
    >
      <h4>
        {{ $t("email_notif") }}
      </h4>
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <v-layout justify-center align-center class="mt-4 pt-2">
      <v-flex id="f-contact" xs12 sm4 md4 lg4 xl4>
        <h2 class="pb-4 mt-2">
          <h3 class="ma-5 title-big">E-visa Cameroun</h3>
        </h2>
        <img :src="img" alt="myphoto" class="contact-img" />
      </v-flex>

      <v-flex id="s-contact" xs12 sm4 md4 lg4 xl4>
        <h2 class="pb-4 mb-4">
          <span>{{ $t("contact_title") }}</span>
        </h2>
        <v-form>
          <v-text-field
            name="name"
            color="blue-grey--text"
            background-color="transparent"
            v-model="name"
            :error-messages="nameErrors"
            :label="this.getLocaleMessages['fullname']"
            required
            @blur="$v.name.$touch()"
          ></v-text-field>
          <v-text-field
            type="email"
            color="blue-grey--text"
            background-color="transparent"
            name="email"
            v-model="email"
            :error-messages="emailErrors"
            label="E-mail"
            required
            @blur="$v.email.$touch()"
          ></v-text-field>
          <v-textarea
            color="blue-grey--text"
            background-color="transparent"
            :error-messages="bodyErrors"
            v-model="body"
            :label="this.getLocaleMessages['comment']"
            name="body"
            @blur="$v.body.$touch()"
          ></v-textarea>
          <v-btn
            @click="submit"
            color="green"
            class="white--text mr-4 my-4"
            :loading="isLoading"
            :disabled="this.$v.$invalid"
            >{{ $t("contact_btn") }}</v-btn
          >
          <v-btn class="mr-4 my-4" color="primary" @click="clear">{{
            $t("contact_clear")
          }}</v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import img from "../../public/contact.png";
import { validationMixin } from "vuelidate";
import { required, email, helpers } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
const nameRegex = helpers.regex(
  "alphaNum",
  /^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$/
);

export default {
  name: "Contact",
  mixins: [validationMixin],
  validations: {
    name: { required, nameRegex },
    email: { required, email },
    body: { required },
  },
  data() {
    return {
      img: img,
      isLoading: false,
      name: "",
      email: "",
      body: "",
      notif: "",
      shownotif: false,
    };
  },
  created() {
    this.$root.$i18n.locale = this.langLocal;
    this.$store.dispatch("setCurrentRoute", this.$route.name);
  },
  methods: {
    async submit() {
      this.$v.$touch();
      this.isLoading = true;
      let data = new FormData();
      data.append("nom_prenom", this.name);
      data.append("email", this.email);
      data.append("message", this.body);
      if (!this.$v.$invalid) {
        await this.$store.dispatch("contact", data).then((response) => {
          this.shownotif = true;
          this.isLoading = false;
          this.clear();
        });
      }
    },
    clear() {
      this.$v.$reset();
      this.name = "";
      this.email = "";
      this.body = "";
    },
  },
  computed: {
    getLocaleMessages() {
      return this.$root.$i18n.messages[this.langLocal];
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required &&
        errors.push(this.getLocaleMessages["required_fullname"]);
      !this.$v.name.nameRegex &&
        errors.push(this.getLocaleMessages["caracter_lastname"]);
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email &&
        errors.push(this.getLocaleMessages["valid_email"]);
      !this.$v.email.required &&
        errors.push(this.getLocaleMessages["required_email"]);
      return errors;
    },
    bodyErrors() {
      const errors = [];
      if (!this.$v.body.$dirty) return errors;
      !this.$v.body.required &&
        errors.push(this.getLocaleMessages["required_comment"]);
      return errors;
    },
    ...mapGetters(["current_route", "langLocal"]),
  },
};
</script>

<style lang="scss" scoped>
#f-contact {
  padding: 20px;
}
#s-contact {
  padding: 20px;
}
#contact-grid {
  margin-top: 120px;
  width: 100%;
  min-height: 70vh;
}
.contact-img {
  max-width: 100%;
}
.w3l-footer {
  position: fixed;
  left: 0px;
  bottom: 0px;
  z-index: 100;
  width: 100%;
}

@media (max-width: 700px) {
  #f-contact {
    display: none;
  }
}
</style>